'use strict';

var $cache = {};
var airports = {
    departure: [],
    destination: {}
};

var DEBUG_ENABLED = false;
var debug = function () {
    if (DEBUG_ENABLED && typeof console !== 'undefined' && console.debug) {
        console.debug.apply(console, arguments);
    }
};

module.exports = {
    $cache: $cache,
    airports: airports,
    debug: debug
};
